import {StatusPageSystemMetricsBulkDeleteAction} from "@/pages/statuspages/tabs/systemMetrics/systemMetricsTable/subComponents/StatusPageSystemMetricsBulkDeleteAction.tsx";

interface TableBulkActionsBarProps {
  selectedItems: Record<string, boolean>;
  setSelectedItems: (selectedItems: Record<string, boolean>) => void;
  statusPageId: number;
}

export const TableBulkActionsBar = ({selectedItems, setSelectedItems, statusPageId}: TableBulkActionsBarProps) => (
  <StatusPageSystemMetricsBulkDeleteAction
    selectedItems={selectedItems}
    setSelectedItems={setSelectedItems}
    statusPageId={statusPageId}
  />
);
